import patient_svg from "../resources/svg/patient.svg"

function PatientIcon() {
    return (
        <div className={"p-2 bg-orange-300 w-fit rounded-full"}>
            <img width={35} src={patient_svg} />
        </div>
    )
}

export default PatientIcon
